import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import api from '../utils/api';
import Home from '../pages/Home';

/**
 * Resolves `/` from admin setting homeLandingEnabled:
 * - enabled → Home hub
 * - disabled → first cup in navbar drag order (fallback worldcup)
 */
const LandingRedirect = () => {
  const [state, setState] = useState({
    loading: true,
    homeLandingEnabled: false,
    defaultCupSlug: 'worldcup',
    heroFeaturedMatch: null,
  });

  useEffect(() => {
    let cancelled = false;
    const controller = new AbortController();
    const failOpen = () => {
      if (cancelled) return;
      setState({
        loading: false,
        homeLandingEnabled: true,
        defaultCupSlug: 'worldcup',
        heroFeaturedMatch: null,
      });
    };
    const watchdog = window.setTimeout(failOpen, 8000);
    (async () => {
      try {
        const { data } = await api.get('/settings/landing', { signal: controller.signal, timeout: 7000 });
        if (cancelled) return;
        window.clearTimeout(watchdog);
        setState({
          loading: false,
          homeLandingEnabled: !!data?.homeLandingEnabled,
          defaultCupSlug: data?.defaultCupSlug || 'worldcup',
          heroFeaturedMatch: data?.heroFeaturedMatch || null,
        });
      } catch (err) {
        console.warn('[Landing] Could not load landing config:', err?.message || err);
        window.clearTimeout(watchdog);
        failOpen();
      }
    })();
    return () => {
      cancelled = true;
      window.clearTimeout(watchdog);
      controller.abort();
    };
  }, []);

  if (state.loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-950">
        <div className="animate-spin rounded-full h-11 w-11 border-2 border-red-600 border-t-transparent" />
      </div>
    );
  }

  if (state.homeLandingEnabled) {
    return <Home heroFeaturedMatch={state.heroFeaturedMatch} />;
  }

  return <Navigate to={`/cup/${state.defaultCupSlug}`} replace />;
};

export default LandingRedirect;
